import { cn } from 'src/lib/utils';
import {
  EVENT_CATEGORY_STYLES,
  formatEventTypeLabel,
  type CollapsedEventChip,
} from '../utils/user-journey.utils';

interface EventChipProps {
  chip: CollapsedEventChip;
  className?: string;
}

export function EventChip({ chip, className }: EventChipProps) {
  const styles = EVENT_CATEGORY_STYLES[chip.category];
  const label = formatEventTypeLabel(chip.eventType);

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-[0.1px]',
        styles.chip,
        className,
      )}
    >
      {chip.count > 1 ? `${label} ×${chip.count}` : label}
    </span>
  );
}
